import { useState } from 'react';
import { RenewalStatusClient, RenewalStatusDTO } from '../services/apiClient';
import { API_BASE_URL } from '../config/config';
import axiosInstance from '../services/axiosInstance';

export const useRenewalStatusApi = () => {
    const apiClient = new RenewalStatusClient(API_BASE_URL, axiosInstance);

    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const create = async (data: RenewalStatusDTO) => {
        setIsLoading(true);
        try {
            await apiClient.createRenewalStatus(data);
        } catch (err: any) {
            setError(err.message || 'Error creating RenewalStatus');
        } finally {
            setIsLoading(false);
        }
    };

    const edit = async (id: string, data: RenewalStatusDTO) => {
        setIsLoading(true);
        try {
            await apiClient.updateRenewalStatus(id, data);
        } catch (err: any) {
            setError(err.message || 'Error updating RenewalStatus');
        } finally {
            setIsLoading(false);
        }
    };

    const getById = async (id: string) => {
        setIsLoading(true);
        try {
            return await apiClient.getRenewalStatusById(id);
        } catch (err: any) {
            setError(err.message || 'Error fetching RenewalStatus');
        } finally {
            setIsLoading(false);
        }
    };

    const search = async (filters: any) => {
        setIsLoading(true);
        try {
            return await apiClient.searchRenewalStatuses(filters);
        } catch (err: any) {
            setError(err.message || 'Error searching RenewalStatuses');
        } finally {
            setIsLoading(false);
        }
    };

    const remove = async (id: string) => {
        setIsLoading(true);
        try {
            await apiClient.deleteRenewalStatus(id);
        } catch (err: any) {
            setError(err.message || 'Error deleting RenewalStatus');
        } finally {
            setIsLoading(false);
        }
    };

    return { create, edit, getById, search, remove, isLoading, error };
};